import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const ServiceModule = {
  getList: async () => {
    try {
      const response = await apiService.get("/ourservices");
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },

  create: async (data) => {
    const response = await apiService.post("/ourservices", data);
    return response.data;
  },

  update: async (id, updatedData) => {
    console.log("back called");
    try {
      console.log(id);

      const response = await apiService.put(`/ourservices/${id}`, updatedData);
      console.log(response.data);
      return response.data;
    } catch (err) {
      console.log("error");
      console.log(err);
      console.log(err.message);
    }
  },

  getDetail: async (id) => {
    const response = await apiService.get(`/ourservices/${id}`);
    return response.data;
  },
  getBySlug: async (id) => {
    const response = await apiService.get(`/ourservices/slug?slug=${id}`);
    return response.data;
  },

  delete: async (id) => {
    console.log(id);
    const response = await apiService.delete(`/ourservices/${id}`);
    console.log("called", response);
    return response.data;
  },
  checkSlug: async (data) => {
    const response = await apiService.post("/ourservices/check-slug", data);
    return response.data;
  },
};

export default ServiceModule;
